import script from "./CreateLimitsReportDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateLimitsReportDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CreateLimitsReportDialog.vue?vue&type=style&index=0&id=1e9cd7e2&lang=sass"

const __exports__ = script;

export default __exports__